const indexData = [
  { icon: 'ri-heart-pulse-line', title: '甜宠国产剧', count: 326, desc: '高糖分恋爱剧集' },
  { icon: 'ri-emotion-laugh-line', title: '都市情感剧', count: 218, desc: '都市情侣必看' },
  { icon: 'ri-ancient-gate-line', title: '古装仙侠剧', count: 195, desc: '古风浪漫传奇' },
  { icon: 'ri-global-line', title: '韩剧经典', count: 287, desc: '高分口碑韩剧' },
  { icon: 'ri-tv-2-line', title: '热播新剧', count: 142, desc: '每日同步更新' },
  { icon: 'ri-fire-line', title: '悬疑刑侦', count: 164, desc: '一起烧脑追凶' },
  { icon: 'ri-sun-line', title: '青春校园', count: 98, desc: '青涩恋爱回忆' },
  { icon: 'ri-moon-line', title: '深夜剧场', count: 73, desc: '高分冷门好剧' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-16 md:py-24 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-800 mb-3">
            剧集分类
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            按类型快速找到最适合情侣一起看的电视剧全集
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {indexData.map((item, idx) => (
            <a
              key={idx}
              href="#index"
              className="group bg-background-50 border border-secondary-200/70 rounded-xl p-5 text-center transition-all hover:border-primary-200/60 hover:shadow-sm"
            >
              <div className="w-11 h-11 mx-auto mb-3 flex items-center justify-center rounded-xl bg-accent-100 text-accent-600 group-hover:bg-accent-500 group-hover:text-white transition-all">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-sm font-bold text-foreground-700 mb-1 group-hover:text-primary-600 transition-colors">
                {item.title}
              </h3>
              <p className="text-xs text-foreground-400 mb-2">{item.desc}</p>
              <span className="text-xs text-primary-500 font-medium">{item.count} 部剧集</span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}